import { render, staticRenderFns } from "./MemberApplicationHealthAssessment.vue?vue&type=template&id=bd4edf2a"
import script from "./MemberApplicationHealthAssessment.vue?vue&type=script&lang=js"
export * from "./MemberApplicationHealthAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports